import axiosInstance from "./axiosInstance";

class PermissaoEscolhaApi {
    async obter() {
        const { data } = await axiosInstance.get(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/permissao_escolha`
        );
        return data;
    }

    async salvar(perfilEscolhido) {
        const { data } = await axiosInstance.post(
            `${process.env.VUE_APP_BASE_API_URL}/api/v1/permissao_escolha`,
            { perfil_escolhido: perfilEscolhido }
        );
        return data;
    }
}

export default PermissaoEscolhaApi;
